export { default } from "./inbox.api";

export * from "./inbox.api.types";
